<script>

	import { onMount, onDestroy, createEventDispatcher } from 'svelte';
	import { fade } from 'svelte/transition';

	import Button from './Button.svelte';

	import { overlays } from '../lib/stores.js';

	const dispatch = createEventDispatcher();

	export let modal = false;
	export let tall = true;
	export let narrow = false;
	export let wide = false;
	export let extrawide = false;
	export let nested = false;

	onMount(() => {
		$overlays++;
	});

	onDestroy(() => {
		$overlays--;
	});

	function handleKeydown(event){
		if (!modal) {
			if (event.key === 'Escape') {
				dispatch('escape');
			}
		}
	}

	function backgroundClick() {
		if (!modal) {
			dispatch('escape');
		}
	}

	function autoClose() {
		dispatch('escape');			
	}

</script>

<style>

	/*.overlay {
		position: fixed;
		inset: 0;
		z-index: 12001;
	}*/

	.overlay {
		position: fixed;
		inset: 0;
		display: grid;
		place-content: center;
		z-index: 12002;
	}

	.overlay:before {
		content: '';
		position: absolute;
		inset: 0;
		background: var(--bgColor);
		/*opacity: 0.6;*/
		opacity: 0.9;
	}

	.overlay > div {
		box-sizing: border-box;
		background: var(--bgColor);
		color: var(--textColor);
		box-shadow: 0 20px 80px var(--shadow);
		border: 1px solid var(--blend-10);
		border-radius: 4px;
		display: flex;
		flex-direction: column;
		transition: width 0.4s ease, transform 0.2s ease, filter 0.2s ease, height 0.2s ease, top 0.2s ease;
		position: absolute;
		left: 0.5rem;
		right: 0.5rem;
		top: calc(50% - 25vh);
		height: 50vh;
	}

	@media screen and (orientation:landscape) {
		.overlay > div {
			bottom: 0.5rem;
			top: 0.5rem;
			height: unset;
			right: unset;
			left: calc(50% - 30vw);
			width: 60vw;
		}
	}

	.overlay.narrow > div {
		/*width: 460px;*/
		/*width: 27rem;*/
		width: clamp(30vw, 25rem, 95vw);
	}

	.overlay.wide > div {
		width: clamp(40vw, 40rem, 95vw);
	}

	.overlay.extrawide > div {
		width: clamp(60vw, 60rem, 95vw);
	}

	/*.overlay.vc > div {
		border-radius: 8px;
	}*/

	.overlay.nested > div {
		transform: scale(0.8);
		filter: blur(2px);
	}

	/*.overlay .close {
		position: absolute;
		top: 0;
		right: 0;
		width: 3.4rem;
		height: 3.4rem;
		background: transparent;
		color: var(--textColor);
		border: 0;
		z-index: 8000;
	}
	.overlay .close:hover,
	.overlay .close:active,
	.overlay .close:focus {
		color: var(--accentColor);
	}
	.overlay .close svg {
		position: absolute;
		inset: 0.5rem;
	}*/

	.overlay :global(.overlay-title) {
		flex: 0 0 auto;
		padding: 2rem 3rem;
	}

	.overlay :global(.overlay-title h2) {
		margin: 0;
		font-size: 1.3rem;
	}

	.overlay :global(.overlay-title h2 + p) {
		margin: 0.5rem 0 0 0;
		/*font-size: 0.6875rem;*/
		font-size: 0.9rem;
	}

	.overlay :global(.overlay-main) {
		flex: 1 0 auto;
		overflow-y: auto;
		padding: 1rem 3rem;
		max-height: calc(80vh - 8rem);
		max-height: calc(80dvh - 8rem);
		background: var(--blend-10);
		position: relative;
	}

	.overlay.tall > div {
		bottom: 0.5rem;
		top: calc(0.5rem + env(safe-area-inset-top));
		height: unset;
	}

	.overlay.tall :global(.overlay-main) {
		max-height: unset;
		flex: 1 1 auto;
	}

	/*.overlay.vc.tall > div {
		top: calc(50% - 44vh);
		bottom: unset;
		height: 90vh;
	}

	@media screen and (orientation:landscape) {
		.overlay.vc.tall > div {
			top: 0.5rem;
		}
	}*/

	.overlay :global(.overlay-actions) {
		flex: 0 0 auto;
		display: flex;
		gap: 1rem;
		padding: 1.4rem 3rem;
	}

	@media (max-width: 600px) {

		.overlay :global(.overlay-title) {
			padding: 2rem 30px;
		}

		.overlay :global(.overlay-main) {
			padding: 1rem 30px;
		}

		.overlay :global(.overlay-actions) {
			padding: 1.4rem 30px;
		}

	}

</style>

<svelte:window on:keydown|stopPropagation={handleKeydown}/>

<!-- svelte-ignore a11y-click-events-have-key-events -->
<div
	class="overlay"
	in:fade={{ duration: 200, delay: 100 }}
	out:fade={{ duration: 100 }}
	on:click={backgroundClick}
	class:tall
	class:narrow
	class:wide
	class:extrawide
	class:nested
>
	<div on:click|stopPropagation>
		<Button close={true} on:click={() => { dispatch('escape') }}/>
		<slot/>
	</div>
</div>